'use strict';
import * as $j_app$002eapi$002e$002dDrug$002dRequest$002dPharmacy$002dState$0024$002dChat$002dStarted from "./app.api.-Drug-Request-Pharmacy-State$-Chat-Started.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_DrugRequestPharmacyState$$anon$30() {
}
export { $c_Lapp_api_DrugRequestPharmacyState$$anon$30 as $c_Lapp_api_DrugRequestPharmacyState$$anon$30 };
$c_Lapp_api_DrugRequestPharmacyState$$anon$30.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_DrugRequestPharmacyState$$anon$30.prototype.constructor = $c_Lapp_api_DrugRequestPharmacyState$$anon$30;
/** @constructor */
function $h_Lapp_api_DrugRequestPharmacyState$$anon$30() {
}
export { $h_Lapp_api_DrugRequestPharmacyState$$anon$30 as $h_Lapp_api_DrugRequestPharmacyState$$anon$30 };
$h_Lapp_api_DrugRequestPharmacyState$$anon$30.prototype = $c_Lapp_api_DrugRequestPharmacyState$$anon$30.prototype;
$c_Lapp_api_DrugRequestPharmacyState$$anon$30.prototype.compose__F1__F1 = (function(g) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_F1__compose__F1__F1(this, g);
});
$c_Lapp_api_DrugRequestPharmacyState$$anon$30.prototype.andThen__F1__F1 = (function(g) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_F1__andThen__F1__F1(this, g);
});
$c_Lapp_api_DrugRequestPharmacyState$$anon$30.prototype.toString__T = (function() {
  return "<function1>";
});
$c_Lapp_api_DrugRequestPharmacyState$$anon$30.prototype.apply__Lapp_api_DrugRequestPharmacyState__Z = (function(a) {
  return ((a instanceof $j_app$002eapi$002e$002dDrug$002dRequest$002dPharmacy$002dState$0024$002dChat$002dStarted.$c_Lapp_api_DrugRequestPharmacyState$ChatStarted) && (a !== null));
});
$c_Lapp_api_DrugRequestPharmacyState$$anon$30.prototype.apply__O__O = (function(v1) {
  return this.apply__Lapp_api_DrugRequestPharmacyState__Z(v1);
});
$c_Lapp_api_DrugRequestPharmacyState$$anon$30.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return this.apply__Lapp_api_DrugRequestPharmacyState__Z(v1);
});
var $d_Lapp_api_DrugRequestPharmacyState$$anon$30 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_DrugRequestPharmacyState$$anon$30, "app.api.DrugRequestPharmacyState$$anon$30", ({
  Lapp_api_DrugRequestPharmacyState$$anon$30: 1,
  F1: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction1: 1
}));
export { $d_Lapp_api_DrugRequestPharmacyState$$anon$30 as $d_Lapp_api_DrugRequestPharmacyState$$anon$30 };
//# sourceMappingURL=app.api.-Drug-Request-Pharmacy-State$$anon$30.js.map
